const newsletter = (fetcher) => ({
  subscribe: (email) =>
    fetcher('/subscribe-newsletter', {
      method: 'POST',
      body: { email },
    }),
})

export default newsletter
